import React from 'react';
import FilePicker from "../file-picker/FilePicker";
import AudioListParcel from "../../api/endpoints/audio/AudioListParcel";
import AudioUploadParcel from "../../api/endpoints/audio/AudioUploadParcel";
import {AUDIO_EXTENSIONS, AUDIO_MAX_SIZE, AUDIO_MIME_TYPES} from "../../view-constants/files/audio";
import AudioHelper from "../../helpers/AudioHelper";
import __ from "../../i18n";


export default function AudioPicker(
    {
        maxFiles = 12,
        onDone = (records) => undefined,
        onCancel = () => undefined,
    }
) {

    return <FilePicker
        FileListParcel={AudioListParcel}
        FileUploadParcel={AudioUploadParcel}
        maxFiles={maxFiles}
        maxFileSize={AUDIO_MAX_SIZE}
        allowedMimeTypes={AUDIO_MIME_TYPES}
        allowedExtensions={AUDIO_EXTENSIONS}
        renderThumbnail={record => <audio src={AudioHelper.getUrl(record)} controls/>}
        getFileTitle={record => record.title}
        getSelectedSummary={value => {
            if (value.length === 1) {
                return __('Selected: ::title (ID: ::id)', {
                    title: value[0].title,
                    id: String(value[0].id)
                });
            }

            return __('Selected ::count(PLURAL, 1 1 file, ! :@ files)', {
                count: value.length
            });
        }}
        onDone={onDone}
        onCancel={onCancel}
    />;
}
